import { Container, Group } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';
import React from 'react';

import { SectionHeaderWithButton } from '../ManageCollaborators/screens/components/SectionHeaderWithButton';
import { PlanSettingContainer } from './Components/PlanSettingContainer/PlanSettingContainer';
import { SubscriptionBillingHistory } from './Components/SubscriptionBillingHistory/SubscriptionBillingHistory.widget';
import { SubscriptionPlansSelect } from './SubscriptionPlansSelect.widget';

export const SubscriptionPlansSettingsScreen = () => {
  const { formatMessage } = useMelioIntl();

  return (
    <Container>
      <Group variant="vertical" spacing="xl" data-testid="subscription-plans">
        <PlanSettingContainer>
          <SectionHeaderWithButton title={formatMessage('widgets.subscriptionPlanSettings.title.currentPlan')} />
          <SubscriptionPlansSelect />
        </PlanSettingContainer>

        <PlanSettingContainer>
          <SectionHeaderWithButton title={formatMessage('widgets.subscriptionPlanSettings.title.billingHistory')} />
          <SubscriptionBillingHistory />
        </PlanSettingContainer>
      </Group>
    </Container>
  );
};
